<template>
  <div class="user-mgr-page">
    <a-card>
      <div class="user-mgr-layout">
        <!-- 右侧内容区 -->
        <div class="main-content">
          <div class="user-mgr-header">
            <a-input placeholder="请输入关键词" style="width: 220px; margin-right: 16px;" />
            <a-button type="primary">+ 新增用户</a-button>
          </div>
          <div class="user-mgr-list">
            <div class="user-mgr-group">工业平台（1人）</div>
            <a-table :columns="columns" :data-source="dataSource" :pagination="false" size="middle">
              <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'action'">
                  <a style="color:#1677ff; margin-right:8px;">编辑</a>
                  <a style="color:#1677ff; margin-right:8px;">详情</a>
                  <a style="color:#ff4d4f;">删除</a>
                </template>
              </template>
            </a-table>
            <div class="user-mgr-pagination">
              <span>共1条</span>
              <a-pagination :total="1" :pageSize="10" :current="1" style="margin: 0 16px;" />
              <a-select :value="10" style="width: 90px;">
                <a-select-option :value="10">10条/页</a-select-option>
                <a-select-option :value="20">20条/页</a-select-option>
              </a-select>
            </div>
          </div>
        </div>
      </div>
    </a-card>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import SystemSideMenu from '@/components/SystemSideMenu.vue'

const selectedKeys = ref(['user-mgr'])
const openKeys = ref(['system'])
const router = useRouter()
const route = useRoute()

// 页面加载和路由变化时自动高亮
watch(
  () => route.path,
  (path) => {
    if (path === '/system/user-mgr') selectedKeys.value = ['user-mgr']
    else if (path === '/system/feedback') selectedKeys.value = ['feedback']
    else if (path === '/system/sync') selectedKeys.value = ['sync']
    else selectedKeys.value = []
    openKeys.value = ['system']
  },
  { immediate: true }
)

function onMenuSelect({ key }: { key: string }) {
  selectedKeys.value = [key]
  if (key === 'feedback') router.push('/system/systemConfig/feedback')
  else if (key === 'user-mgr') router.push('/system/systemConfig/user-mgr')
  else if (key === 'sync') router.push('/system/systemConfig/sync')
  // 其它菜单可按需跳转
}

const columns = [
  { title: '用户ID', dataIndex: 'id', key: 'id' },
  { title: '用户名', dataIndex: 'username', key: 'username' },
  { title: '昵称', dataIndex: 'nickname', key: 'nickname' },
  { title: '标签', dataIndex: 'tag', key: 'tag' },
  { title: '创建时间', dataIndex: 'createdAt', key: 'createdAt' },
  { title: '联系电话', dataIndex: 'phone', key: 'phone' },
  { title: '邮箱', dataIndex: 'email', key: 'email' },
  { title: '设备数', dataIndex: 'deviceCount', key: 'deviceCount' },
  { title: '状态', dataIndex: 'status', key: 'status' },
  { title: '操作', key: 'action' }
]
const dataSource = [
  {
    id: '1740358057038188544',
    username: 'administrator',
    nickname: '超级管理员',
    tag: '-',
    createdAt: '2023-05-02 11:33',
    phone: '-',
    email: '-',
    deviceCount: 0,
    status: '正常'
  },{
    id: '5558265232688482957',
    username: 'ys.yes',
    nickname: '杨胜',
    tag: '-',
    createdAt: '2023-05-08 11:33',
    phone: '-',
    email: '-',
    deviceCount: 0,
    status: '正常'
  },{
    id: '5558265232688482957',
    username: 'sarah.cheng',
    nickname: '陈心佩',
    tag: '-',
    createdAt: '2023-05-08 11:35',
    phone: '-',
    email: '-',
    deviceCount: 0,
    status: '正常'
  },{
    id: '5558265232688482957',
    username: 'xiaoxi.yuan',
    nickname: '袁小希',
    tag: '-',
    createdAt: '2023-05-08 11:40',
    phone: '-',
    email: '-',
    deviceCount: 0,
    status: '正常'
  },{
    id: '5558265232688482957',
    username: 'chang.wu',
    nickname: '吴畅',
    tag: '-',
    createdAt: '2023-05-08 11:45',
    phone: '-',
    email: '-',
    deviceCount: 0,
    status: '正常'
  },{
    id: '5558265232688482957',
    username: 'jun.you',
    nickname: '游钧',
    tag: '-',
    createdAt: '2023-05-08 11:55',
    phone: '-',
    email: '-',
    deviceCount: 0,
    status: '正常'
  },{
    id: '5558265232688482957',
    username: 'jun.liu',
    nickname: '刘俊',
    tag: '-',
    createdAt: '2023-05-08 12:05',
    phone: '-',
    email: '-',
    deviceCount: 0,
    status: '正常'
  },{
    id: '5558265232688482957',
    username: 'hongsheng.jia',
    nickname: '贾红胜',
    tag: '-',
    createdAt: '2023-05-08 12:10',
    phone: '-',
    email: '-',
    deviceCount: 0,
    status: '正常'
  }
]
</script>

<style lang="less" scoped>
.user-mgr-page {
  padding: 24px;
  background: #f5f7f9;
  min-height: 100vh;
  .user-mgr-layout {
    display: flex;
    .side-menu {
      width: 220px;
      background: #f8fafb;
      border-radius: 4px;
      margin-right: 16px;
      padding: 16px 0;
      min-height: 600px;
    }
    .main-content {
      flex: 1;
      background: #fff;
      border-radius: 4px;
      padding: 24px;
      .user-mgr-header {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
      }
      .user-mgr-list {
        .user-mgr-group {
          font-weight: bold;
          margin-bottom: 8px;
        }
        .user-mgr-pagination {
          display: flex;
          align-items: center;
          margin-top: 12px;
        }
      }
    }
  }
}
</style> 